import * as yup from 'yup'
import { MESSAGES } from '../../utils/constants'

export const otpSchema = yup.object().shape({
    otp: yup
        .string()
        .trim(MESSAGES.error.verificationCode)
        .min(6, MESSAGES.error.verificationCode)
        .max(6, MESSAGES.error.verificationCode)
        .required(MESSAGES.error.verificationCode),
})
